<template>
  <q-dialog
    v-model="dialogRef"
    :position="isMobile ? 'bottom' : 'standard'"
    :persistent="outsideClickCloseDisable"
    @hide="onDialogHide"
  >
    <q-card class="removeCartItem">
      <q-card-section class="row items-center q-pb-none" v-if="closeBtn">
        <q-space />
        <q-btn icon="close" flat round dense v-close-popup />
      </q-card-section>

      <q-card-section class="inner text-center">
        <h5 v-html="text" />
        <p v-html="description" />
        <div>
          <q-btn
            unelevated
            rounded
            outline
            color="tertiary"
            :label="cancelBtnLabel"
            padding="14px 30px"
            class="q-ma-sm radius-lg"
            @click="onCancelClick"
          />
          <q-btn
            unelevated
            rounded
            color="secondaryOnBody"
            :label="confirmBtnLabel"
            padding="14px 30px"
            class="q-ma-sm radius-lg"
            @click="onOKClick"
          />
        </div>
      </q-card-section>
    </q-card>
  </q-dialog>
</template>
<script>
import { defineComponent, ref } from 'vue'
import { useDialogPluginComponent } from 'quasar'

export default defineComponent({
  name: 'CustomConfirm',
  props: {
    text: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    cancelBtnLabel: {
      type: String,
      default: 'No',
    },
    confirmBtnLabel: {
      type: String,
      default: 'Yes',
    },
    closeBtn: {
      type: Boolean,
      default: true,
    },
    outsideClickCloseDisable: {
      type: Boolean,
      default: false,
    },
  },
  emits: [...useDialogPluginComponent.emits], // Ensures required emits are present
  setup(props, { emit }) {
    const dialogRef = ref(false)

    const onDialogHide = () => {
      // required to be emitted
      // when QDialog emits "hide" event
      emit('hide')
    }

    const onOKClick = () => {
      // on OK, it is REQUIRED to
      // emit "ok" event (with optional payload)
      // before hiding the QDialog
      emit('ok') // Emit OK event
      dialogRef.value = false // Hide the dialog after OK
    }

    const onCancelClick = () => {
      // we just need to hide dialog
      dialogRef.value = false // Hide the dialog after cancel
    }

    return {
      dialogRef,
      onDialogHide,
      onOKClick,
      onCancelClick,
    }
  },
})
</script>
